import React, { useState, useEffect } from "react";
import { Input,InputNumber, Form, Col, Row, Button, notification, Upload } from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const DivisionAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.post(`/TransactionProjectType`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const downloadExcelTemplate = () => {
    window.open(
      `${config.apiUrl
      }/TransactionProjectType/DownloadExcel?t=${RequestHandler.getToken()}&type=3`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${config.apiUrl
      }/TransactionProjectType/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}&name=sorumluluk-merkezi`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/TransactionProjectType/ImportExcel?type=3`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="DivisionAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item hidden name="ProjectType" initialValue="BolumKodu">
            <Input />
          </Form.Item>
          <Form.Item
            label="Bölüm Adı"
            name="name"
            rules={[
              {
                required: true,
                message: "Lütfen Bölüm Adını boş bırakmayın.",
              },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item
            label="Bölüm Kodu"
            name="projectCode"
            rules={[
              {
                required: true,
                message: "Lütfen Bölüm Kodu alanını boş bırakmayın.",
              },
            ]}
          >
            <InputNumber min={0} precision={0} style={{ width: "100%" }} />
          </Form.Item>

          <Row justify="space-between">
            <Col>
              <Button
                icon={<DownloadOutlined />}
                onClick={(() => setLoading(true), downloadExcelTemplate)}
                loading={loading}
              >
                Excel Şablonu İndir
              </Button>
              <Upload {...uploadExcelProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
              </Upload>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default DivisionAddForm;
